import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BarChart } from '@mui/x-charts/BarChart';
import {defaultVariables} from "../../../../../config";
import {useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid2";
import {Typography} from "@mui/material";
import {CircleOff} from "lucide-react";

const ProfitBarChart = ({manage}) => {
    const [xAxisData, setXAxisData] = useState([]);
    const [yAxisData, setYAxisData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasData, setHasData] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        axios.get(`${defaultVariables.url}/profits/${!!manage ? "chart" : "user-chart"}`,{
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('ACT')}`
            }
        })
            .then(res => {
                const chartData = res.data;
                if(chartData.length > 0){
                    setXAxisData(chartData.map(item => item.date));
                    setYAxisData(chartData.map(item => item.total));
                    setHasData(true)
                }else{

                    setHasData(false)
                }

                setLoading(false);
            })
            .catch(err => console.error(err));
    }, []);

    return (
        <Grid contianer spacing={2} className={ !hasData  && "emptyChart"}>
            {
                !loading &&
                <Grid item size={12} >
                    {
                        !!hasData  ?
                        <BarChart
                            xAxis={[{ data: xAxisData, scaleType: 'band' }]}
                            series={[{ data: yAxisData, label: t('profit_amount'),color: "#489E21"} ]}
                            height={300}
                            margin={{ left: 50, right: 50, top: 60, bottom: 50 }}
                            grid={{ vertical: true, horizontal: true }}
                        />
                            :
                            <div className='text-center d-flex flex-column' style={{alignItems:'center', gap:20, height:'80%'}}>
                                <CircleOff className='lucide-icon-gray lucide-xl'/>
                                <Typography className="font-13">{t('noProfitIsHere')}</Typography>
                            </div>


                    }

                </Grid>
            }

        </Grid>
    );
};

export default ProfitBarChart;
